export default __webpack_public_path__ + "static/media/success.07017859.svg";